<script>
  import ProductImage from "@shared/svelte/Components/ProductImage.svelte";
  import FormErrors from "@shared/svelte/Components/FormErrors.svelte";
  import fileUtils from "@shared/lib/file_from_drop";
  import { HttpPromise } from "@shared/svelte/Modules/ApiService";

  export let productLine;
  export let loading;

  let errors;
  const dimensions = {
    min_width: 80,
    min_height: 80,
    max_file_size: 5
  }
  $: inputEl = null;
  let dragging = false;
  let fileData;

  function startDragging() {
    dragging = true;
  }
  function stopDragging() {
    dragging = false;
  }

  export const saveImage = async function() {
    loading = true;
    if (!fileData) {
      return (loading = false);
    }

    var formData = new FormData();
    formData.append("image_upload[file]", fileData);
    formData.append("image_upload[entity_type]", 'SellSheetProductLine');

    if (productLine.id) {
      formData.append("image_upload[entity_id]", productLine.id.toString());
    }

    Object.keys(dimensions).forEach(function (dim) {
      if (dim && dimensions[dim]) {
        formData.append(`image_upload[${dim}]`, dimensions[dim]);
      }
    });

    try {
      let res = await HttpPromise({
        method: "POST",
        url: `/api/${window.C.APP_NAME}/image_uploads`,
        data: formData,
      })
      loading = false;
      fileData = null;
      productLine.cloudinary_image_url = res.cloudinary_image_url;
      productLine.image_upload_id = res.id;
      if (res.dimensions_message) {
        errors = { messages: [res.dimensions_message] };
      }
      return productLine
    } catch (error) {
      loading = false;
      errors = {messages: [error]};
    }
  };

  const uploadFromDrop = event => {
    stopDragging();
    fileData = fileUtils.getFilesFromDropEvent(event)[0];
  };

  const uploadFromBrowse = event => {
    stopDragging();
    fileData = event.target.files[0];
  };
</script>

<FormErrors errors={errors} />
<div class='grid-row margin-bottom--small'>
  <div class='grid-col c12-12 align-center margin-bottom--small'>
    <div class="fizz-image-container fizz-stack-16">
      <ProductImage product={productLine} fizz={true} className="noop" height={80} width={80} />
    </div>
  </div>
  <div class='grid-col c12-12'>
    <div class='grid-col c12-12'>
      <div class="label input__label--left padding-bottom--smallest align-left">
        Upload Image
      </div>
      <div class="media full-width margin-top--small margin-bottom--small">
        <label
          id="drop-target-{productLine.id}"
          for="file-upload-header-image-{productLine.id}"
          class="fizz-file-upload fizz-stack-8 cursor-pointer"
          class:dragging
          on:drop|preventDefault={uploadFromDrop}
          on:dragover|preventDefault={startDragging}
          on:dragleave|preventDefault={stopDragging}
        >
          <input
            type="file"
            on:change={uploadFromBrowse}
            id="file-upload-header-image-{productLine.id}"
            bind:this={inputEl}
          />
          {#if !fileData}
            <span>{dragging ? "Drop" : "Click"} to upload</span>
          {:else}
            <span>Image uploaded - click Save below</span>
          {/if}
        </label>
        <p class="fizz-text-small-subdued fizz-stack-16 padding-left--smaller" style="white-space: pre-line">
          Upload a new product image for this product sheet
        </p>
      </div>
    </div>
  </div>
</div>
